import React from "react"
import classnames from "classnames"
import { ToastPopup, InfoIcon, ButtonIcon } from "AtomicComponents"
import styles from "./Disclaimer.less"

class Disclaimer extends React.Component {
  constructor(props){
    super(props)
    this.state = {
      show: false,
      uniqueID: Math.random()
    }
  }

  componentDidUpdate(prevProps) {
    const { show } = this.props

    if (prevProps.show !== show && show) {
      this._handleOnClick()
    }
  }

  _handleOnClick = () => {
    this.setState({
      show: true
    })
  }

  _handleOnClose = () => {
    this.setState({
      show: false
    })
  }

  render() {
    const { children, Icon = InfoIcon, text = null, gtm } = this.props
    const { show, uniqueID } = this.state
    return (
      <div className={classnames({
        [styles.Disclaimer]: true,
        [styles.DisclaimerText]: text
      })}>
        <div className={classnames({
          [styles.DisclaimerIcon]: true
        })}>
          <ButtonIcon onClick={this._handleOnClick} gtm={gtm}>
            { !text &&
              <Icon style={{ width: "0.5em", height: "0.5em", color: "#910A2D" }} />
            }
            { text && <span style={{color: "#910A2D"}}>{text}</span> }
          </ButtonIcon>
        </div>
        {
          show &&
            <ToastPopup
              uniqueID={`DisclaimerID-${uniqueID}`}
              onClose = {this._handleOnClose}
            >
              <div className={classnames({
                [styles.DisclaimerToast]: true
              })}>
                <div className={classnames({
                  [styles.DisclaimerToastIcon]: true
                })}>
                  { !text ?
                    <Icon />
                    :
                    <span style={{fontSize: "3em"}}>{text}</span>
                  }
                </div>
                <p className={classnames({
                  [styles.DisclaimerContent]: true
                })}>
                  {children}
                </p>
              </div>
            </ToastPopup>
        }
      </div>
    )
  }
}

export default Disclaimer



// WEBPACK FOOTER //
// ./src/AtomicContainers/Disclaimer/Disclaimer.jsx